import { createAction } from '@reduxjs/toolkit';

export default createAction('noop', payload => {
  return {
    payload,
  };
});
